import Loadable from 'UIComponents/decorators/Loadable';
const AsyncSuspensionBanner = Loadable({
  loader: () => import( /* webpackChunkName: "suspension-banner" */'email-health-ui-lib/suspension/components/SuspensionBanner'),
  LoadingComponent: () => null
});
export default AsyncSuspensionBanner;